import {
  Button,
  Link,
  StatusIndicator,
  TableProps,
} from "@amzn/awsui-components-react";
import { Transaction } from "../../lusca-search-api/generated-src";
import { GL_MAPPING } from "../../hooks/useSummaryData";
import { UATProject, UATStatus } from "../../types/UATProject";

export const COLUMN_DEFINITIONS: TableProps.ColumnDefinition<UATProject>[] = [
  {
    id: "id",
    header: "UAT Name",
    width: 350,
    cell: (run: UATProject) => (
      <Link href={`?project=${encodeURIComponent(run.id)}`}>{run.name}</Link>
    ),
    sortingField: "id",
  },
  {
    id: "marketplace",
    header: "Marketplace",
    cell: (run: UATProject) => run.marketplace,
    sortingField: "marketplace",
  },
  {
    id: "gl",
    header: "GL",
    cell: (run: UATProject) =>
      `${GL_MAPPING[run.GLPG] || run.GLPG} (${run.GLPG})`,
    sortingField: "gl",
  },
  {
    id: "status",
    header: "Status",
    cell: (run: UATProject) => {
      const statusValue =
        typeof run.status === "number" ? UATStatus[run.status] : run.status;

      const statusEnum =
        typeof run.status === "number"
          ? run.status
          : UATStatus[run.status as keyof typeof UATStatus];

      switch (statusEnum) {
        case UATStatus.PENDING:
          return (
            <StatusIndicator type="pending">{statusValue}</StatusIndicator>
          );
        case UATStatus.FAILED:
          return <StatusIndicator type="error">{statusValue}</StatusIndicator>;
        case UATStatus.AWAITING_REVIEW:
          return (
            <StatusIndicator type="in-progress">{statusValue}</StatusIndicator>
          );
        case UATStatus.PASSED:
          return (
            <StatusIndicator type="success">{statusValue}</StatusIndicator>
          );
        case UATStatus.APPROVED:
          return (
            <StatusIndicator type="success">{statusValue}</StatusIndicator>
          );
        case UATStatus.BLOCKED:
          return (
            <StatusIndicator type="stopped">{statusValue}</StatusIndicator>
          );
        case UATStatus.RETEST:
          return (
            <StatusIndicator type="warning">{statusValue}</StatusIndicator>
          );
        default:
          return <StatusIndicator type="info">{statusValue}</StatusIndicator>;
      }
    },
    sortingField: "status",
  },
  {
    id: "dueDate",
    header: "Due Date",
    cell: (run: UATProject) => {
      const date = new Date(run.due_date);
      return date.toLocaleDateString();
    },
    sortingField: "dueDate",
  },
  {
    id: "owner",
    header: "Owner",
    cell: (run: UATProject) => run.owner,
    sortingField: "owner",
  },
];

export const ORDER_VALIDATION_COLUMN_DEFINITIONS: TableProps.ColumnDefinition<Transaction>[] =
  [
    {
      id: "id",
      header: "UAT ID",
      width: 350,
      cell: (item: Transaction) => (
        <Link
          href={`?stage=${encodeURIComponent(
            item.stage
          )}&transactionId=${encodeURIComponent(item.id)}`}
        >
          {item.id}
        </Link>
      ),
      sortingField: "id",
    },
    {
      id: "country",
      header: "Country",
      cell: (item: Transaction) => item.country,
      sortingField: "country",
    },
    {
      id: "gl",
      header: "GL",
      cell: (item: Transaction) =>
        `${GL_MAPPING[item.gl] || item.gl} (${item.gl})`,
      sortingField: "gl",
    },
    {
      id: "usecase",
      header: "Usecase",
      width: 200,
      cell: (item: Transaction) => {
        item.usecase;
      },
      sortingField: "usecase",
    },
    {
      id: "status",
      header: "Status",
      width: 100,
      cell: (item: Transaction) => {
        item.usecase;
      },
      sortingField: "status",
    },
    {
      id: "actions",
      header: "Actions",
      cell: (item) => (
        <Button variant="inline-link" ariaLabel="Remove">
          Remove
        </Button>
      ),
      minWidth: 170,
    },
  ];
